import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import Documents from './Documents'
import Videos from './Videos'
import Firmware from './Firmware'
import Troubleshooting from './Troubleshooting'
import UnitsLanguages from './UnitsLanguages'
import ProductModels from './ProductModels'
import SpareParts from './SpareParts'
import DashboardHeader from '../common/DashboardHeader/DashboardHeader'
import WrappedTabs from '../common/WrappedTabs'
import Breadcrumb from '../common/Breadcrumb'
import './uploads.scss'

const Uploads = (props) => {
  const { t } = useTranslation()
  const history = useHistory()
  const location = useLocation()
  const [availablePages, setAvailablePages] = useState([])
  const [selectedPage, setSelectedPage] = useState(null)
  const uploadPages = [
    {
      key: 0,
      slug: 'documents',
      title: 'nav.documents',
      content: <Documents />,
      permission: 'page:document-upload',
    },
    {
      key: 1,
      slug: 'videos',
      title: 'nav.videos',
      content: <Videos />,
      permission: 'page:videos-upload',
    },
    {
      key: 2,
      slug: 'firmware',
      title: 'device_context.firmware',
      content: <Firmware />,
      permission: 'page:firmware-upload',
    },
    {
      key: 3,
      slug: 'troubleshooting',
      title: 'nav.troubleshoot',
      content: <Troubleshooting />,
      permission: 'page:troubleshooting-upload',
    },
    {
      key: 4,
      slug: 'units-languages',
      title: 'nav.units_languages',
      content: <UnitsLanguages />,
      permission: 'page:units-languages',
    },
    {
      key: 5,
      slug: 'product-models',
      title: 'nav.product_models',
      content: <ProductModels />,
      permission: 'page:device-models',
    },
    {
      key: 6,
      slug: 'spare-parts',
      title: 'nav.spareparts',
      content: <SpareParts />,
      permission: 'page:device-models',
    },
  ]

  useEffect(() => {
    const permissionArr = props.userPermissions ? (Array.isArray(props.userPermissions) ? props.userPermissions : Object.values(props.userPermissions)) : []
    const allowedPages = uploadPages.filter((page) => permissionArr.includes(page.permission?.toLowerCase()))
    setAvailablePages(allowedPages)
    if (!allowedPages.length) {
      setSelectedPage(null)
      return
    }

    const params = new URLSearchParams(location.search)
    const contentParam = params.get('content')
    let activePage = allowedPages[0]

    if (contentParam) {
      const match = allowedPages.find((p) => p.slug === contentParam)
      if (match) activePage = match
    }
    setSelectedPage(activePage)

    const expectedQuery = `?content=${activePage.slug}`
    if (location.search !== expectedQuery) {
      history.replace({ search: expectedQuery })
    }
  }, [props.userPermissions])

  const handleTabClick = (index) => {
    const page = availablePages.find((p) => p.key === index)
    if (!page) return
    setSelectedPage(page)
    const newSearch = `?content=${page.slug}`
    history.push({ search: newSearch })
  }

  return (
    <div className="uploads-wrapper">
      <Breadcrumb path={window.location.pathname} />
      <DashboardHeader headerText={t('nav.content_management')} />
      <WrappedTabs
        className="main-page-tabs-wrapper"
        tabs={availablePages.map((page) => ({ id: page.key, name: page.title }))}
        activeTab={selectedPage?.key}
        changeTab={handleTabClick}
      />
      {selectedPage?.content}
    </div>
  )
}

function mapStateToProps({ userPermissions }) {
  return {
    userPermissions,
  }
}

export default connect(mapStateToProps)(Uploads)

